"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleSelection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var styles_1 = __importDefault(require("./styles"));
var atoms_1 = require("../../atoms");
var icons_1 = require("../../icons");
exports.MultipleSelection = react_1.default.memo(function (_a) {
    var globalValue = _a.value, options = _a.options, existingSelections = _a.existingSelections, id = _a.id, dropdownLabel = _a.dropdownLabel, onSelectionChange = _a.onSelectionChange, textFieldProps = _a.textFieldProps, isFetching = _a.isFetching, setSearchHandle = _a.setSearchHandle, onSelectAllCallBack = _a.onSelectAllCallBack, _b = _a.showCheckbox, showCheckbox = _b === void 0 ? false : _b, checkboxLabel = _a.checkboxLabel, onCheckboxChange = _a.onCheckboxChange, name = _a.name, rest = __rest(_a, ["value", "options", "existingSelections", "id", "dropdownLabel", "onSelectionChange", "textFieldProps", "isFetching", "setSearchHandle", "onSelectAllCallBack", "showCheckbox", "checkboxLabel", "onCheckboxChange", "name"]);
    var classes = (0, styles_1.default)();
    var _c = (0, react_1.useState)(existingSelections), selections = _c[0], setSelections = _c[1];
    var _d = (0, react_1.useState)(false), selectAllSelected = _d[0], setSelectAllSelected = _d[1];
    var _e = (0, react_1.useState)(false), enableUnselectAll = _e[0], setEnableUnSelectAll = _e[1];
    var _f = (0, react_1.useState)("".concat(existingSelections.length > 0 ? "".concat(existingSelections.length, " selected") : '')), inputHandler = _f[0], setInputHandler = _f[1];
    var optionsMemo = (0, react_1.useMemo)(function () { return __spreadArray([{ value: 'ALL-SELECTED', text: 'Select all' }], options, true); }, [
        options,
    ]);
    var cleanedSelectionLength = (0, react_1.useMemo)(function () { return selections.filter(function (val) { return val.value !== 'ALL-SELECTED'; }).length; }, [selections]);
    var onRemove = (0, react_1.useCallback)(function (expectedValue) {
        var newArray = selections.filter(function (v) { return v.value !== expectedValue; });
        setSelections(newArray);
        onSelectionChange(newArray);
    }, [onSelectionChange, selections]);
    // This handle the state of the SELECT ALL option and the autocomplete input
    (0, react_1.useEffect)(function () {
        var filteredSelections = selections.filter(function (val) { return val.value !== 'ALL-SELECTED'; });
        if (filteredSelections.length > 0)
            setSelectAllSelected(true);
        if (filteredSelections.length === 0)
            setSelectAllSelected(false);
    }, [selections]);
    // This update the selection when the globalValue changes, this is needed for the following use case :
    //  When a user clicks the SELECT ALL option we need to fetch all the existing options and select them
    (0, react_1.useEffect)(function () {
        if (globalValue)
            setSelections(globalValue);
    }, [globalValue]);
    var handleSelectAll = (0, react_1.useCallback)(function () {
        setSelections(__spreadArray([], optionsMemo, true));
        onSelectionChange(__spreadArray([], optionsMemo, true));
    }, [onSelectionChange, optionsMemo]);
    var handleUnSelectAll = (0, react_1.useCallback)(function () {
        setSelections([]);
        onSelectionChange([]);
    }, [onSelectionChange]);
    var onDeleteChips = (0, react_1.useCallback)(function (selected) {
        setInputHandler("".concat(cleanedSelectionLength > 1 ? "".concat(cleanedSelectionLength - 1, " selected") : ''));
        onRemove(selected.value);
    }, [cleanedSelectionLength, onRemove]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.InputLabel, __assign({ className: classes.dropdownLabel, id: "multiple-checkbox-label" }, { children: dropdownLabel })), (0, jsx_runtime_1.jsx)(Autocomplete_1.default, __assign({}, rest, { disableCloseOnSelect: true, disableClearable: true, loading: isFetching, value: selections, onChange: function (e, newValue, reason) {
                    if (reason === 'select-option' &&
                        newValue.find(function (val) { return val.value === 'ALL-SELECTED'; })) {
                        handleSelectAll();
                        if (onSelectAllCallBack)
                            onSelectAllCallBack();
                        setEnableUnSelectAll(true);
                    }
                    else if (reason === 'remove-option' &&
                        !newValue.find(function (val) { return val.value === 'ALL-SELECTED'; }) &&
                        enableUnselectAll) {
                        setEnableUnSelectAll(false);
                        handleUnSelectAll();
                    }
                    else {
                        setSelections(newValue);
                        onSelectionChange(newValue);
                    }
                }, multiple: true, options: optionsMemo, getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.text) || ''; }, getOptionSelected: function (option, value) { return option.value === value.value; }, renderTags: function () { return null; }, inputValue: inputHandler, onOpen: function () { return setInputHandler(''); }, onClose: function () {
                    return setInputHandler("".concat(cleanedSelectionLength > 0 ? "".concat(cleanedSelectionLength, " selected") : ''));
                }, renderOption: function (option, _a) {
                    var selected = _a.selected;
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [option.value !== 'ALL-SELECTED' ? ((0, jsx_runtime_1.jsx)(atoms_1.Checkbox, { id: "checkBox-".concat(option.value), checked: selected })) : ((0, jsx_runtime_1.jsx)(atoms_1.Checkbox, { id: "checkBox-".concat(option.value), checked: selectAllSelected, indeterminate: selections.length < optionsMemo.length, onClick: function () { return handleSelectAll; } })), option.text] }));
                }, renderInput: function (params) { return ((0, jsx_runtime_1.jsx)(atoms_1.TextField, __assign({ label: "" }, params, textFieldProps, { name: name, id: id, fullWidth: true, onChange: function (event) {
                        setInputHandler(event.target.value);
                        setSearchHandle(event.target.value);
                    }, style: {
                        marginTop: 0,
                    }, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isFetching ? (0, jsx_runtime_1.jsx)(core_1.CircularProgress, { color: "inherit", size: 20 }) : null, params.InputProps.endAdornment] })) }) }))); }, popupIcon: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ width: 20, height: 24 }, { children: (0, jsx_runtime_1.jsx)(icons_1.ChevronDown, {}) })) })), showCheckbox && ((0, jsx_runtime_1.jsx)(atoms_1.Checkbox, { id: "multiSelectionCheckBox", label: checkboxLabel, onChange: function () {
                    if (onCheckboxChange)
                        onCheckboxChange();
                } })), (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: classes.selectionDisplay }, { children: selections
                    .filter(function (value) { return value.value !== 'ALL-SELECTED'; })
                    .map(function (selected) { return ((0, jsx_runtime_1.jsx)("span", __assign({ className: classes.selectionTag }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Tag, { id: selected.value, size: "small", text: selected.text, canDelete: true, onDelete: function () { return onDeleteChips(selected); } }) }), selected.value)); }) }))] }));
});
